<mat-form-field class="full-width" role="search">
    <span matPrefix><mat-icon>search</mat-icon></span>
    <input
        matInput
        placeholder="Search"
        i18n-placeholder="@@input-label-search"
        autoFocused
        [formControl]="searchInput"
        name="search"
        (input)="searchChanged.emit(searchInput.value)" />
    <button
        *ngIf="searchInput.value"
        matSuffix
        mat-icon-button
        class="riege-button riege-button--icon"
        #input
        aria-label="Reset search"
        i18n-aria-label="@@input-search-clear"
        (click)="searchInput.reset(); input.focus(); searchChanged.emit('')">
        <mat-icon class="riege-icon">close</mat-icon>
    </button>
</mat-form-field>
